import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import {
  AppBar,
  Tabs,
  Tab,
  makeStyles,
  Grid,
  Button,
  Typography,
  TextField,
  Icon,
  Box,
  Container,
  CardHeader,
  Divider,
  CardContent,
  Card,
  Paper,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import PropTypes from "prop-types";

import * as brandActions from "src/redux/actions/brand.action";
import * as departmentActions from "src/redux/actions/department.action";
import * as yearActions from "src/redux/actions/year.action";

//Special owner
import * as countryspecialActions from "src/redux/actions/countryspecial.action";
import * as companyspecialActions from "src/redux/actions/companyspecial.action";
import * as brandspecialActions from "src/redux/actions/brandspecial.action";
import * as departmentspecialActions from "src/redux/actions/departmentspecial.action";
import * as getspecialActions from "src/redux/actions/getspecial.action";
import * as insertspecialActions from "src/redux/actions/insertspecial.action";
import * as updatespecialActions from "src/redux/actions/updatespecial.action";
import * as deletespecialActions from "src/redux/actions/deletespecial.action";
import * as deletespecialbyidActions from "src/redux/actions/deletespecialbyid.action";
//Special owner

import * as budgetsActions from "src/redux/actions/budgets.action";

import CustomDialog from "src/components/fragments/CustomDialog";
import NumberFormat from "react-number-format";
import Page from "src/components/Page";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles((theme) => ({

  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  inputEditNumber: {
    width: "10ch",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    // border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix=""
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
export default function Special() {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  // Owner Box
  const [brandId, setBrandId] = useState(null);
  const [deptId, setDeptId] = useState(null);
  const [yearId, setYearId] = useState(null);
  const [yearLock, setYearLock] = useState(null);
  // Department Box
  const [countryIdD, setCountryIdD] = useState(null);
  const [companyIdD, setCompanyIdD] = useState(null);
  const [brandIdD, setbrandIdD] = useState(null);
  const [deptIdD, setdeptIdD] = useState(null);
  const [chksearch, setChksearch] = useState(0);

  const [formSearch, setFormSearch] = useState({});
  const [checkRecSpecial, setCheckRecSpecial] = useState(true);
  const [checkRecRemove, setcheckRecRemove] = useState(true);
  const [checkLock, setCheckLock] = useState(true);
  //-------------------------------------
  const [userauth, setUserauth] = useState({
    usernameauth: "",
  });
  const [openDlgconfirm, setopenDlgconfirm] = useState(false);
  const [openDlgSpecial, setOpenDlgSpecial] = useState(false);

  const budgetmonthReducer = useSelector(
    ({ budgetmonthReducer }) => budgetmonthReducer
  );
  // const budgetsReducer = useSelector(({ budgetsReducer }) => budgetsReducer);
  const yearReducer = useSelector(({ yearReducer }) => yearReducer);
  const budgetsReducer = useSelector(
    ({ budgetsReducer }) => budgetsReducer,
    shallowEqual
  );
  // const { countries, isFetching, isError } = useSelector(
  //   ({ userauthReducer }) => userauthReducer
  // );
  const loginReducer = useSelector((state) => state.loginReducer, shallowEqual);
  const brandReducer = useSelector((state) => state.brandReducer);
  const departmentReducer = useSelector(
    ({ departmentReducer }) => departmentReducer
  );
  const companyspecialReducer = useSelector(
    (state) => state.companyspecialReducer
  );
  const countryspecialReducer = useSelector(
    (state) => state.countryspecialReducer
  );
  const brandspecialReducer = useSelector((state) => state.brandspecialReducer);
  const departmentspecialReducer = useSelector(
    (state) => state.departmentspecialReducer
  );
  const getspecialReducer = useSelector(
    (state) => state.getspecialReducer,
    shallowEqual
  );
  // const brandReducer = useSelector(({ brandReducer }) => brandReducer);

  const dispatch = useDispatch();

  useEffect(
    () => {
      dispatch(
        brandActions.getBrands(
          loginReducer.result.countryid,
          loginReducer.result.companyid,
          loginReducer.result.secureid
        )
      );
      dispatch(countryspecialActions.getCountrysSpecial());
      return () => {
        dispatch(
          getspecialActions.getSpecialAll(
            0,
            0,
            loginReducer.result.companyid,
            loginReducer.result.countryid,
            0,
            0,
            0,
            0
          )
        );
        dispatch(budgetsActions.getBudgetsById(0, 0, 0, 0, 0, 0));
      };
    },
    []
    // [countryid, companyid, brandId, deptId, yearId]
  );

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  const handleChangeBrand = (e) => {
    const data = e.target.value;
    setBrandId(data);
    setDeptId(null);
    setChksearch(0);
    clearDataDropDown();
    e.preventDefault();
    // dispatch(usernameauthActions.getUserauth(e.target.value))
    dispatch(
      departmentActions.getDepts(
        loginReducer.result.countryid,
        loginReducer.result.companyid,
        loginReducer.result.secureid,
        data
      )
    );
    setCheckRecSpecial(true);
    setcheckRecRemove(true);
    dispatch(budgetsActions.clearBudgets());
    dispatch(getspecialActions.clearSpecialAll());
  };
  const handleChangeDepartment = (e) => {
    const data = e.target.value;
    clearDataDropDown();
    setYearId(null);
    setChksearch(0);
    e.preventDefault();
    dispatch(
      yearActions.getYear(
        loginReducer.result.countryid +
          loginReducer.result.companyid +
          brandId +
          data
      )
    );
    setDeptId(data);
    setCheckRecSpecial(true);
    setcheckRecRemove(true);
    dispatch(budgetsActions.clearBudgets());
    dispatch(getspecialActions.clearSpecialAll());
  };

  const handleChangeYear = (e) => {
    // const { BUDGETH_ID, YEAR_CODE, BUDGETH_LOCK } = e.target.value;
    const { BUDGETH_ID, YEAR_CODE, BUDGETH_LOCK } = JSON.parse(e.target.value);
    clearDataDropDown();
    // console.log(BUDGETH_LOCK);
    setYearId(BUDGETH_ID);
    setYearLock(BUDGETH_LOCK);
    setChksearch(0);
    // alert(yearLock);
    if (yearLock === 1) {
      setCheckLock(true);
    } else {
      // setYearLock(null);
      setCheckLock(false);
    }
    setCheckRecSpecial(true);
    setcheckRecRemove(true);
    dispatch(budgetsActions.clearBudgets());
    dispatch(getspecialActions.clearSpecialAll());
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeCountrySP = (e) => {
    const data = e.target.value;

    setCountryIdD(data);
    setCompanyIdD(null);
    setChksearch(0);
    clearDataDropDown();
    e.preventDefault();
    dispatch(companyspecialActions.getCompanysSpecial(data));

    setCheckRecSpecial(true);
    setcheckRecRemove(true);
    dispatch(budgetsActions.clearBudgets());
    dispatch(getspecialActions.clearSpecialAll());
  };
  const handleChangeCompanySP = (e) => {
    const data = e.target.value;
    setCompanyIdD(data);
    setbrandIdD(null);
    setChksearch(0);
    clearDataDropDown();
    e.preventDefault();
    // dispatch(usernameauthActions.getUserauth(e.target.value))
    dispatch(brandspecialActions.getBrandsSpecial(data));
    setCheckRecSpecial(true);
    setcheckRecRemove(true);
    dispatch(budgetsActions.clearBudgets());
    dispatch(getspecialActions.clearSpecialAll());
  };
  const handleChangeBrandSP = (e) => {
    const data = e.target.value;
    setbrandIdD(data);
    setdeptIdD(null);
    setChksearch(0);
    clearDataDropDown();
    e.preventDefault();
    // dispatch(usernameauthActions.getUserauth(e.target.value))
    dispatch(departmentspecialActions.getDeptsSpecial(data));

    setCheckRecSpecial(true);
    setcheckRecRemove(true);
    dispatch(budgetsActions.clearBudgets());
    dispatch(getspecialActions.clearSpecialAll());
  };
  const handleChangeDepartmentSP = (e) => {
    const data = e.target.value;
    clearDataDropDown();
    e.preventDefault();
    setdeptIdD(data);
    setChksearch(0);
    setCheckRecSpecial(true);
    setcheckRecRemove(true);
    dispatch(budgetsActions.clearBudgets());
    dispatch(getspecialActions.clearSpecialAll());
  };

  const handleConfirmDlg = (value) => {
    if (value) {
      let data = {
        YEARID: yearId,
        COUNTRYID: loginReducer.result.countryid,
        COMPANYID: loginReducer.result.companyid,
        BRANDID: brandId,
        DEPARTID: deptId,
        M_ID: loginReducer.result.perid,
        W_COUNTRYID: countryIdD,
        W_COMPANYID: companyIdD,
        W_BRANDID: brandIdD,
        W_DEPARTID: deptIdD,
      };

      setTimeout(() => {
        dispatch(deletespecialActions.deleteBudgetOById(data));
      }, 1000);
      setTimeout(() => {
        dispatch(
          getspecialActions.getSpecialAll(
            loginReducer.result.companyid,
            brandId,
            deptId,
            yearId,
            countryIdD,
            companyIdD,
            brandIdD,
            deptIdD
          )
        );
      }, 1000);
      setCheckRecSpecial(false);
      setcheckRecRemove(true);
      setopenDlgconfirm(false);
    } else {
      setCheckRecSpecial(true);
      setcheckRecRemove(false);
      setopenDlgconfirm(false);
    }
  };

  const clearDataDropDown = (e) => {
    dispatch(getspecialActions.clearSpecialAll());
  };

  const handleConfirmDlgSpecial = (value) => {
    if (value) {
      let data = {
        YEARID: yearId,
        COUNTRYID: loginReducer.result.countryid,
        COMPANYID: loginReducer.result.companyid,
        BRANDID: brandId,
        DEPARTID: deptId,
        M_ID: loginReducer.result.perid,
        W_COUNTRYID: countryIdD,
        W_COMPANYID: companyIdD,
        W_BRANDID: brandIdD,
        W_DEPARTID: deptIdD,
      };

      // setTimeout(() => {
      dispatch(insertspecialActions.insertSpecialById(data));
      // }, 1000);
      setTimeout(() => {
        dispatch(
          getspecialActions.getSpecialAll(
            loginReducer.result.companyid,
            brandId,
            deptId,
            yearId,
            countryIdD,
            companyIdD,
            brandIdD,
            deptIdD
          )
        );
      }, 1000);
      setCheckRecSpecial(true);
      setcheckRecRemove(false);
      setOpenDlgSpecial(false);
    } else {
      setOpenDlgSpecial(false);
    }
  };

  const checkEditSpecial = (rowData) => {
    if (yearLock === 0) {
      if (budgetsReducer.actid === 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
    //  rowData.BUDGETS_APPROVER === 0,
  };

  const controlLoadSpecial = () => {
    const result = budgetsReducer.actid + yearLock;
    if (result >= 1) {
      return true;
    } else {
      return false;
    }
  };

  const renderButtonLoadSpecial = () => {
    // if (budgetsReducer.result.length > 0) {
    // if (controlLoadSpecial() === true) {
    return (
      <Button
        variant="contained"
        color="default"
        startIcon={<Icon>add</Icon>}
        disabled={controlLoadSpecial()}
        onClick={(e) => {
          setOpenDlgSpecial(true);
        }}
      >
        Load special owner
      </Button>
    );
    // }
    // return;
  };
  const tableRef = React.createRef();
  return (

    <Page className={classes.root} title="Special Owner">
      <Container maxWidth={false}>
        <Card>
          <CardHeader subheader="For special budget" title="Special Owner" />
          {yearLock === 1 ? (
            <Alert icon={false} severity="warning">
              <Typography variant="button" display="block">
                Year Locked
              </Typography>
            </Alert>
          ) : (
            ""
          )}
          {budgetsReducer.actid + budgetsReducer.appid > 1 ? (
              <Alert icon={false} severity="success">
                <Typography variant="button" display="block">
                  Approved.
                </Typography>
              </Alert>
            ) : budgetsReducer.actid === 1 ? (
              <Alert icon={false} severity="warning">
                <Typography variant="button" display="block">
                  Waiting for approve.
                </Typography>
              </Alert>
            ) : (
              ""
            )}
          <Divider />
          <CardContent>
            <form
              className={classes.formsearch}
              onSubmit={(e) => {
                e.preventDefault();
                dispatch(
                  getspecialActions.getSpecialAll(
                    loginReducer.result.companyid,
                    brandId,
                    deptId,
                    yearId,
                    countryIdD,
                    companyIdD,
                    brandIdD,
                    deptIdD
                  )
                )
                  .then((result) => {
                    // console.log(result);
                    if (result > 0) {
                      if (yearLock === 0) {
                        setCheckRecSpecial(true);
                        setcheckRecRemove(false);
                      } else {
                        setCheckRecSpecial(true);
                        setcheckRecRemove(true);
                      }
                    } else {
                      setCheckRecSpecial(false);
                      setcheckRecRemove(true);
                    }
                    setChksearch(1);
                    dispatch(
                      budgetsActions.getBudgetsById(
                        countryIdD,
                        companyIdD,
                        brandIdD,
                        deptIdD,
                        yearId,
                        loginReducer.result.secureid
                      )
                    );
                  })

                  .catch((result) => {
                    // Error Message
                  });
              }}
            >
              {/* TAB */}
              <Grid container md={12} xs={12}>
                <Box
                  display="flex"
                  flex={1}
                  flexDirection="column"
                  // flexWrap="wrap"
                  // style={{ backgroundColor: "black" }}
                  p={2}
                >
                  <Box>
                    <Typography variant="h5">From Owner</Typography>
                  </Box>
                  <Box>
                    <Box
                      flex={1}
                      // flexDirection="column"
                      // style={{ backgroundColor: "cyan" }}
                    >
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        select
                        autoFocus
                        onChange={handleChangeBrand}
                        id="brand"
                        label="Brand"
                        style={{ width: "30%" }}
                        SelectProps={{
                          native: true,
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        defaultValue=""
                        // autoComplete="Brand"
                      >
                        <option key={0} value="" selected>
                          -
                        </option>
                        {brandReducer.result &&
                          brandReducer.result.map((item) => (
                            <option
                              key={item.ORG_BRAND_ID}
                              value={item.ORG_BRAND_ID}
                            >
                              {item.BRAND}
                            </option>
                            // <MenuItem value={item.ORG_BRAND_ID}>
                            //   {item.BRAND}
                            // </MenuItem>
                          ))}
                      </TextField>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        select
                        onChange={handleChangeDepartment}
                        label="Department"
                        autoComplete="department"
                        style={{ width: "60%", marginLeft: 10 }}
                        SelectProps={{
                          native: true,
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        defaultValue=""
                      >
                        <option key={0} value="" selected>
                          -
                        </option>

                        {departmentReducer.result &&
                          departmentReducer.result.map((item) => (
                            <option
                              key={item.ORG_DEPARTMENT_ID}
                              value={item.ORG_DEPARTMENT_ID}
                            >
                              {item.department}
                            </option>
                          ))}
                      </TextField>
                    </Box>
                  </Box>
                  <Box flex={1}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      style={{ width: "30%" }}
                      select
                      onChange={handleChangeYear}
                      label="Year"
                      autoComplete="year"
                      SelectProps={{
                        native: true,
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      defaultValue=""
                    >
                      <option key={0} value="" selected>
                        -
                      </option>
                      {yearReducer.result &&
                        yearReducer.result.map((item) => (
                          <option
                            key={item.YEAR_CODE}
                            value={JSON.stringify(item)}
                          >
                            {/* {item.YEAR_CODE} */}
                            {item.YEAR_SEQ_T}
                          </option>
                          // <MenuItem value={item}>{item.YEAR_CODE}</MenuItem>
                        ))}
                      {/* ))} */}
                    </TextField>
                  </Box>
                </Box>
                <Box
                  display="flex"
                  flex={1}
                  flexDirection="column"
                  // flexWrap="wrap"
                  // style={{ backgroundColor: "black" }}
                  p={2}
                >
                  <Box>
                    <Typography variant="h5">To Department</Typography>
                  </Box>
                  <Box>
                    <Box
                      flex={1}
                      // flexDirection="column"
                      // style={{ backgroundColor: "cyan" }}
                    >
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        style={{ width: "47%" }}
                        select
                        onChange={handleChangeCountrySP}
                        id="Country"
                        label="Country"
                        autoComplete="Country"
                        SelectProps={{
                          native: true,
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        defaultValue=""
                      >
                        <option key={0} value="" selected>
                          -
                        </option>
                        {countryspecialReducer.result &&
                          countryspecialReducer.result.map((item) => (
                            <option
                              key={item.ORG_COUNTRY_ID}
                              value={item.ORG_COUNTRY_ID}
                            >
                              {item.Country}
                            </option>
                            // <MenuItem value={item.ORG_COUNTRY_ID}>
                            //   {item.Country}
                            // </MenuItem>
                          ))}
                      </TextField>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        // fullWidth
                        style={{ width: "47%", marginLeft: 10 }}
                        select
                        onChange={handleChangeCompanySP}
                        id="company"
                        label="Company"
                        autoComplete="Company"
                        SelectProps={{
                          native: true,
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        defaultValue=""
                      >
                        <option key={0} value="" selected>
                          -
                        </option>
                        {companyspecialReducer.result &&
                          companyspecialReducer.result.map((item) => (
                            <option
                              key={item.ORG_COMPANY_ID}
                              value={item.ORG_COMPANY_ID}
                            >
                              {item.Company}
                            </option>
                            // <MenuItem value={item.ORG_COMPANY_ID}>
                            //   {item.Company}
                            // </MenuItem>
                          ))}
                      </TextField>
                    </Box>
                  </Box>
                  <Box>
                    <Box
                      flex={1}
                      // flexDirection="column"
                      // style={{ backgroundColor: "cyan" }}
                    >
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        // fullWidth
                        style={{ width: "30%" }}
                        select
                        onChange={handleChangeBrandSP}
                        id="brand"
                        label="Brand"
                        autoComplete="Brand"
                        SelectProps={{
                          native: true,
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        defaultValue=""
                      >
                        <option key={0} value="" selected>
                          -
                        </option>
                        {brandspecialReducer.result &&
                          brandspecialReducer.result.map((item) => (
                            <option
                              key={item.ORG_BRAND_ID}
                              value={item.ORG_BRAND_ID}
                            >
                              {item.Brand}
                            </option>
                            // <MenuItem value={item.ORG_BRAND_ID}>
                            //   {item.Brand}
                            // </MenuItem>
                          ))}
                      </TextField>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        style={{ width: "65%", marginLeft: 10 }}
                        // fullWidth
                        select
                        onChange={handleChangeDepartmentSP}
                        label="Department"
                        autoComplete="department"
                        SelectProps={{
                          native: true,
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        defaultValue=""
                      >
                        <option key={0} value="" selected>
                          -
                        </option>
                        {/* --------------------------------------------------------------------
                    if brandIdD <> 221 
                      choose ORG_DEPARTMENT_ID value = 266 
                      Component : AutoComplete
                      --------------------------------------------------------------------*/}
                        {departmentspecialReducer.result &&
                          departmentspecialReducer.result.map((item) => (
                            <option
                              key={item.ORG_DEPARTMENT_ID}
                              value={item.ORG_DEPARTMENT_ID}
                            >
                              {item.Department}
                            </option>
                            // <MenuItem value={item.ORG_DEPARTMENT_ID}>
                            //   {item.Department}
                            // </MenuItem>
                          ))}
                      </TextField>
                    </Box>
                  </Box>
                  <Box>
                    <Box
                      flex={1}
                      display="flex"
                      style={{ justifyContent: "flex-end", marginTop: 10 }}
                      // flexDirection="column"
                      // justifyContent="flex-end"
                    >
                      <Button variant="contained" color="default" type="submit">
                        <Icon>search</Icon>Search
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </form>
            <br />
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  flexWrap="wrap"
                >
                  <Box display="flex" flexDirection="row">
                    <Box mr={5}>
                      {chksearch === 1 ? renderButtonLoadSpecial() : []}
                    </Box>
                    <Box mr={5}>
                      {/* <Button
                  variant="contained"
                  color="secondary"
                  disabled={checkRecRemove}
                  onClick={() => {
                    setopenDlgconfirm(true);
                  }}

                >
                  Delete
                </Button> */}
                    </Box>
                  </Box>
                  {/* <Box display="flex" flexDirection="row">
              <Box>
                <Button
                  variant="contained"
                  color="default"
                  startIcon={<Icon>refresh</Icon>}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(
                      getspecialActions.getSpecialAll(
                        loginReducer.result.companyid,
                        brandId,
                        deptId,
                        yearId,
                        countryIdD,
                        companyIdD,
                        brandIdD,
                        deptIdD
                      )
                    )
                      .then((result) => {
                        // console.log(result);
                        if (result > 0) {
                          if (yearLock === 0) {
                            setCheckRecSpecial(true);
                            setcheckRecRemove(false);
                          } else {
                            setCheckRecSpecial(true);
                            setcheckRecRemove(true);
                          }
                        } else {
                          setCheckRecSpecial(false);
                          setcheckRecRemove(true);
                        }
                      })
                      .catch((result) => {
                        // Error Message
                      });
                  }}
                >
                  Refresh data
                </Button>
              </Box>
            </Box> */}
                </Box>
              </Grid>
            </Grid>
            <br />
            <AppBar position="static">
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="simple tabs example"
                variant="fullWidth"
                centered
              >
                <Tab
                  style={{ backgroundColor: "#5c9aff", color: "#FFFF" }}
                  label="Special Owner"
                  {...a11yProps(0)}
                />
              </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
              {/* Special Tab */}
              <br />
              <Grid container spacing={3}>
                <Paper className={classes.root}>
                <MaterialTable
                  title="Special Owner"
                  on
                  columns={[
                    {
                      title: "Code",
                      field: "ACC_CODE",
                      editable: "never",
                    },
                    {
                      title: "Name",
                      field: "ACC_NAME",
                      editable: "never",
                    },
                    {
                      title: "Total.",
                      // field: "V_BUDGETSD_M1",
                      type: "numeric",
                      editable: "never",
                      render: (rowData) => {
                        if (rowData) {
                          return (
                            rowData.BUDGETO_M1 +
                            rowData.BUDGETO_M2 +
                            rowData.BUDGETO_M3 +
                            rowData.BUDGETO_M4 +
                            rowData.BUDGETO_M5 +
                            rowData.BUDGETO_M6 +
                            rowData.BUDGETO_M7 +
                            rowData.BUDGETO_M8 +
                            rowData.BUDGETO_M9 +
                            rowData.BUDGETO_M10 +
                            rowData.BUDGETO_M11 +
                            rowData.BUDGETO_M12
                          )
                            .toFixed(2)
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                        } else {
                          return "0.00";
                        }
                      },
                    },
                    {
                      title: "Jan.",
                      field: "BUDGETO_M1",
                      editable: (_, rowData) =>
                      rowData && rowData.YEAR_M1 === 0,
                      type: "numeric",
                      render: (rowData) => {
                        if (rowData.BUDGETO_M1) {
                          return rowData.BUDGETO_M1.toFixed(2).replace(
                            /(\d)(?=(\d{3})+(?!\d))/g,
                            "$1,"
                          );
                        } else {
                          return "0.00";
                        }
                      },
                      editComponent: (props) => (
                        <TextField
                          className={classes.inputEditNumber}
                          // label="react-number-format"
                          value={props.value}
                          onChange={(e) =>
                            props.onChange(e.target.value ? e.target.value : 0)
                          }
                          name="numberformat"
                          id="formatted-numberformat-input"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                        />
                      ),
                    },
                    {
                      title: "Feb.",
                      field: "BUDGETO_M2",
                      editable: (_, rowData) =>
                      rowData && rowData.YEAR_M2 === 0,
                      type: "numeric",
                      render: (rowData) => {
                        if (rowData.BUDGETO_M2) {
                          return rowData.BUDGETO_M2.toFixed(2).replace(
                            /(\d)(?=(\d{3})+(?!\d))/g,
                            "$1,"
                          );
                        } else {
                          return "0.00";
                        }
                      },
                      editComponent: (props) => (
                        <TextField
                          className={classes.inputEditNumber}
                          // label="react-number-format"
                          value={props.value}
                          onChange={(e) =>
                            props.onChange(e.target.value ? e.target.value : 0)
                          }
                          name="numberformat"
                          id="formatted-numberformat-input"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                        />
                      ),
                    },
                    {
                      title: "Mar.",
                      field: "BUDGETO_M3",
                      editable: (_, rowData) =>
                      rowData && rowData.YEAR_M3 === 0,
                      type: "numeric",
                      render: (rowData) => {
                        if (rowData.BUDGETO_M3) {
                          return rowData.BUDGETO_M3.toFixed(2).replace(
                            /(\d)(?=(\d{3})+(?!\d))/g,
                            "$1,"
                          );
                        } else {
                          return "0.00";
                        }
                      },
                      editComponent: (props) => (
                        <TextField
                          className={classes.inputEditNumber}
                          // label="react-number-format"
                          value={props.value}
                          onChange={(e) =>
                            props.onChange(e.target.value ? e.target.value : 0)
                          }
                          name="numberformat"
                          id="formatted-numberformat-input"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                        />
                      ),
                    },
                    {
                      title: "Apr.",
                      field: "BUDGETO_M4",
                      editable: (_, rowData) =>
                      rowData && rowData.YEAR_M4 === 0,
                      type: "numeric",
                      render: (rowData) => {
                        if (rowData.BUDGETO_M4) {
                          return rowData.BUDGETO_M4.toFixed(2).replace(
                            /(\d)(?=(\d{3})+(?!\d))/g,
                            "$1,"
                          );
                        } else {
                          return "0.00";
                        }
                      },
                      editComponent: (props) => (
                        <TextField
                          className={classes.inputEditNumber}
                          // label="react-number-format"
                          value={props.value}
                          onChange={(e) =>
                            props.onChange(e.target.value ? e.target.value : 0)
                          }
                          name="numberformat"
                          id="formatted-numberformat-input"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                        />
                      ),
                    },
                    {
                      title: "May",
                      field: "BUDGETO_M5",
                      editable: (_, rowData) =>
                      rowData && rowData.YEAR_M5 === 0,
                      type: "numeric",
                      render: (rowData) => {
                        if (rowData.BUDGETO_M5) {
                          return rowData.BUDGETO_M5.toFixed(2).replace(
                            /(\d)(?=(\d{3})+(?!\d))/g,
                            "$1,"
                          );
                        } else {
                          return "0.00";
                        }
                      },
                      editComponent: (props) => (
                        <TextField
                          className={classes.inputEditNumber}
                          // label="react-number-format"
                          value={props.value}
                          onChange={(e) =>
                            props.onChange(e.target.value ? e.target.value : 0)
                          }
                          name="numberformat"
                          id="formatted-numberformat-input"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                        />
                      ),
                    },
                    {
                      title: "Jun.",
                      field: "BUDGETO_M6",
                      editable: (_, rowData) =>
                      rowData && rowData.YEAR_M6 === 0,
                      type: "numeric",
                      render: (rowData) => {
                        if (rowData.BUDGETO_M6) {
                          return rowData.BUDGETO_M6.toFixed(2).replace(
                            /(\d)(?=(\d{3})+(?!\d))/g,
                            "$1,"
                          );
                        } else {
                          return "0.00";
                        }
                      },
                      editComponent: (props) => (
                        <TextField
                          className={classes.inputEditNumber}
                          // label="react-number-format"
                          value={props.value}
                          onChange={(e) =>
                            props.onChange(e.target.value ? e.target.value : 0)
                          }
                          name="numberformat"
                          id="formatted-numberformat-input"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                        />
                      ),
                    },
                    {
                      title: "Jul.",
                      field: "BUDGETO_M7",
                      editable: (_, rowData) =>
                      rowData && rowData.YEAR_M7 === 0,
                      type: "numeric",
                      render: (rowData) => {
                        if (rowData.BUDGETO_M7) {
                          return rowData.BUDGETO_M7.toFixed(2).replace(
                            /(\d)(?=(\d{3})+(?!\d))/g,
                            "$1,"
                          );
                        } else {
                          return "0.00";
                        }
                      },
                      editComponent: (props) => (
                        <TextField
                          className={classes.inputEditNumber}
                          // label="react-number-format"
                          value={props.value}
                          onChange={(e) =>
                            props.onChange(e.target.value ? e.target.value : 0)
                          }
                          name="numberformat"
                          id="formatted-numberformat-input"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                        />
                      ),
                    },
                    {
                      title: "Aug.",
                      field: "BUDGETO_M8",
                      editable: (_, rowData) =>
                      rowData && rowData.YEAR_M8 === 0,
                      type: "numeric",
                      render: (rowData) => {
                        if (rowData.BUDGETO_M8) {
                          return rowData.BUDGETO_M8.toFixed(2).replace(
                            /(\d)(?=(\d{3})+(?!\d))/g,
                            "$1,"
                          );
                        } else {
                          return "0.00";
                        }
                      },
                      editComponent: (props) => (
                        <TextField
                          className={classes.inputEditNumber}
                          // label="react-number-format"
                          value={props.value}
                          onChange={(e) =>
                            props.onChange(e.target.value ? e.target.value : 0)
                          }
                          name="numberformat"
                          id="formatted-numberformat-input"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                        />
                      ),
                    },
                    {
                      title: "Sep.",
                      field: "BUDGETO_M9",
                      editable: (_, rowData) =>
                      rowData && rowData.YEAR_M9 === 0,
                      type: "numeric",
                      render: (rowData) => {
                        if (rowData.BUDGETO_M9) {
                          return rowData.BUDGETO_M9.toFixed(2).replace(
                            /(\d)(?=(\d{3})+(?!\d))/g,
                            "$1,"
                          );
                        } else {
                          return "0.00";
                        }
                      },
                      editComponent: (props) => (
                        <TextField
                          className={classes.inputEditNumber}
                          // label="react-number-format"
                          value={props.value}
                          onChange={(e) =>
                            props.onChange(e.target.value ? e.target.value : 0)
                          }
                          name="numberformat"
                          id="formatted-numberformat-input"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                        />
                      ),
                    },
                    {
                      title: "Oct.",
                      field: "BUDGETO_M10",
                      editable: (_, rowData) =>
                      rowData && rowData.YEAR_M10 === 0,
                      type: "numeric",
                      render: (rowData) => {
                        if (rowData.BUDGETO_M10) {
                          return rowData.BUDGETO_M10.toFixed(2).replace(
                            /(\d)(?=(\d{3})+(?!\d))/g,
                            "$1,"
                          );
                        } else {
                          return "0.00";
                        }
                      },
                      editComponent: (props) => (
                        <TextField
                          className={classes.inputEditNumber}
                          // label="react-number-format"
                          value={props.value}
                          onChange={(e) =>
                            props.onChange(e.target.value ? e.target.value : 0)
                          }
                          name="numberformat"
                          id="formatted-numberformat-input"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                        />
                      ),
                    },
                    {
                      title: "Nov.",
                      field: "BUDGETO_M11",
                      editable: (_, rowData) =>
                      rowData && rowData.YEAR_M11 === 0,
                      type: "numeric",
                      render: (rowData) => {
                        if (rowData.BUDGETO_M11) {
                          return rowData.BUDGETO_M11.toFixed(2).replace(
                            /(\d)(?=(\d{3})+(?!\d))/g,
                            "$1,"
                          );
                        } else {
                          return "0.00";
                        }
                      },
                      editComponent: (props) => (
                        <TextField
                          className={classes.inputEditNumber}
                          // label="react-number-format"
                          value={props.value}
                          onChange={(e) =>
                            props.onChange(e.target.value ? e.target.value : 0)
                          }
                          name="numberformat"
                          id="formatted-numberformat-input"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                        />
                      ),
                    },
                    {
                      title: "Dec.",
                      field: "BUDGETO_M12",
                      editable: (_, rowData) =>
                      rowData && rowData.YEAR_M12 === 0,
                      type: "numeric",
                      render: (rowData) => {
                        if (rowData.BUDGETO_M12) {
                          return rowData.BUDGETO_M12.toFixed(2).replace(
                            /(\d)(?=(\d{3})+(?!\d))/g,
                            "$1,"
                          );
                        } else {
                          return "0.00";
                        }
                      },
                      editComponent: (props) => (
                        <TextField
                          className={classes.inputEditNumber}
                          // label="react-number-format"
                          value={props.value}
                          onChange={(e) =>
                            props.onChange(e.target.value ? e.target.value : 0)
                          }
                          name="numberformat"
                          id="formatted-numberformat-input"
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                        />
                      ),
                    },
                    {
                      title: "Detail",
                      field: "ACCDETAIL",
                      editable: "never",
                      cellStyle: {
                        whiteSpace: "nowrap",
                      },
                    },
                  ]}
                  tableRef={tableRef}
                  isLoading={getspecialReducer.isFetching}
                  data={
                    getspecialReducer.result ? getspecialReducer.result : []
                  }
                  editable={{
                    isEditable: (rowData) => checkEditSpecial(),
                    isDeletable: (rowData) => checkEditSpecial(),
                    onRowUpdate: (newData, oldData) =>
                      new Promise((resolve, reject) => {
                        const { BUDGETO_ID } = newData;
                        dispatch(
                          updatespecialActions.updateBudgetOById(
                            BUDGETO_ID,
                            loginReducer.result.perid,
                            newData
                          )
                        );

                        resolve();
                      }).then(() => {
                        setTimeout(() => {
                          dispatch(
                            getspecialActions.getSpecialAll(
                              loginReducer.result.companyid,
                              brandId,
                              deptId,
                              yearId,
                              countryIdD,
                              companyIdD,
                              brandIdD,
                              deptIdD
                            )
                          );
                        }, 500);
                      }),
                    // onRowDelete: (newData, oldData) =>
                    //   new Promise((resolve, reject) => {
                    //     const { BUDGETO_ID } = newData;
                    //     // setTimeout(() => {
                    //     dispatch(
                    //       deletespecialbyidActions.deleteBudgetOByIdRec(
                    //         BUDGETO_ID
                    //       )
                    //     );
                    //     // }, 1500);
                    //     resolve();
                    //     // setOpenDlgconfirmByid(true, BUDGETO_ID);
                    //   }).then(() => {
                    //     setTimeout(() => {
                    //       dispatch(
                    //         getspecialActions.getSpecialAll(
                    //           loginReducer.result.companyid,
                    //           brandId,
                    //           deptId,
                    //           yearId,
                    //           countryIdD,
                    //           companyIdD,
                    //           brandIdD,
                    //           deptIdD
                    //         )
                    //       );
                    //     }, 1000);

                    //     setCheckRecSpecial(false);
                    //     setcheckRecRemove(true);
                    //   }),
                  }}
                  options={{
                    // actionsColumnIndex: -1,
                    headerStyle: {
                      backgroundColor: "#5c9aff",
                    },
                    rowStyle: {
                      backgroundColor: "#edf4ff",
                    },
                    showTitle: false,
                    searchFieldAlignment: "left",
                    exportButton: true,
                    toolbarButtonAlignment: "left",
                    exportAllData: true,
                    // fixedColumns: {
                    //   left: 2,
                    // },
                  }}
                />
                </Paper>
              </Grid>
            </TabPanel>
            <CustomDialog
              title="Confirmation dialog"
              message="Confirm to delete special owner ?"
              open={openDlgconfirm}
              onClose={handleConfirmDlg}
            />
            <CustomDialog
              title="Confirmation dialog"
              message="Confirm to Load Special owner?"
              open={openDlgSpecial}
              onClose={handleConfirmDlgSpecial}
            />
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}
